<div class="container-fluid">
    <app-pagetitle title="Access Logs" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
    <div class="row">
        <div class="col-lg-12">

            <div class="card">
                <div class="card-body">
                    <app-filter (filterChange)="filterChange($event)" [filter]="filter"></app-filter>
                    <p-table #dt [value]="logs" [lazy]="true" (onLazyLoad)="loadLogs($event)" [paginator]="true"
                        [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
                        [rowsPerPageOptions]="[10,20,50]" [scrollable]="true" scrollHeight="395px"
                        styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                        <ng-template pTemplate="header">
                            <tr>
                                <th style="min-width:120px">Method</th>
                                <th style="min-width:220px">Endpoint</th>
                                <th style="min-width:120px">Status</th>
                                <th style="min-width:150px">IP</th>
                                <th style="min-width:150px">Response</th>
                                <th style="min-width:180px">Date</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-log>
                            <tr>
                                <td><span class="badge bg-primary">{{ log.method }}</span></td>
                                <td class="text-nowrap">{{ log.endpoint }}</td>
                                <td><span class="badge bg-success">{{ log.statusCode }}</span></td>
                                <td>{{ log.ip }}</td>
                                <td>{{ log.responseTimeMs }} ms</td>
                                <td>{{ log.createdAt | date:'short' }}</td>
                            </tr>
                        </ng-template>

                    </p-table>
                </div>
            </div>
        </div>
    </div>
</div>